import { DataTable, Card, CardActions, CardContent, CardHeader, CardHeading } from '@ucc/react/ui';
import { Box } from '@chakra-ui/react';
import { StyledSelect } from '~/components/Form/StyledSelect';
import { useServiceRequest } from '~/pages/dashboard/hooks/useServiceRequest';
import { integrationLabel } from '~/components/Renderers';

export function ServiceRequests() {
    const { serviceRequests, branches, sourceSystems, selectBranch, selectSourceSystem } =
        useServiceRequest();

    return (
        <Card boxShadow="none">
            <CardHeader>
                <CardHeading>Auftragseingang</CardHeading>
                <CardActions>
                    <Box minW={455} display="flex" gap={2}>
                        <Box w="full">
                            <StyledSelect
                                isClearable
                                name="branch"
                                placeholder="Niederlassung"
                                onChange={(newValue: any) => {
                                    selectBranch(newValue?.value);
                                }}
                                options={branches.map((b) => ({
                                    value: b.id,
                                    label: b.description,
                                }))}
                            />
                        </Box>
                        <Box w="full">
                            <StyledSelect
                                isClearable
                                placeholder="Herkunft"
                                onChange={(newValue: any) => {
                                    selectSourceSystem(newValue?.value);
                                }}
                                options={sourceSystems.map((s) => ({
                                    value: s.source,
                                    label: integrationLabel(s),
                                }))}
                            />
                        </Box>
                    </Box>
                </CardActions>
            </CardHeader>
            <CardContent>
                <DataTable {...serviceRequests} />
            </CardContent>
        </Card>
    );
}
